/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIArticle } from './APIArticle';
import {
    APIArticleFromJSON,
    APIArticleFromJSONTyped,
    APIArticleToJSON,
} from './APIArticle';
import type { APIAddress } from './APIAddress';
import {
    APIAddressFromJSON,
    APIAddressFromJSONTyped,
    APIAddressToJSON,
} from './APIAddress';
import type { APIRequestContact } from './APIRequestContact';
import {
    APIRequestContactFromJSON,
    APIRequestContactFromJSONTyped,
    APIRequestContactToJSON,
} from './APIRequestContact';
import type { APIPriceEntry } from './APIPriceEntry';
import {
    APIPriceEntryFromJSON,
    APIPriceEntryFromJSONTyped,
    APIPriceEntryToJSON,
} from './APIPriceEntry';

/**
 * 
 * @export
 * @interface APIContractSearchResult
 */
export interface APIContractSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APIContractSearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APIContractSearchResult
     */
    score: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIContractSearchResult
     */
    comment?: string;
    /**
     * 
     * @type {number}
     * @memberof APIContractSearchResult
     */
    contractStatus?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIContractSearchResult
     */
    contractStatusDisplay?: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIContractSearchResult
     */
    priorityShipping?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof APIContractSearchResult
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContractSearchResult
     */
    desiredDelivery?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIContractSearchResult
     */
    latestDelivery?: Date | null;
    /**
     * 
     * @type {Array<APIPriceEntry>}
     * @memberof APIContractSearchResult
     */
    priceEntries?: Array<APIPriceEntry>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIContractSearchResult
     */
    priceQuantities?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof APIContractSearchResult
     */
    priceValues?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof APIContractSearchResult
     */
    priceText?: string;
    /**
     * 
     * @type {number}
     * @memberof APIContractSearchResult
     */
    offerId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIContractSearchResult
     */
    requestId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIContractSearchResult
     */
    requestCertificate?: string;
    /**
     * 
     * @type {number}
     * @memberof APIContractSearchResult
     */
    requestStatus?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIContractSearchResult
     */
    requestStatusDisplay?: string;
    /**
     * 
     * @type {APIRequestContact}
     * @memberof APIContractSearchResult
     */
    requestContact?: APIRequestContact | null;
    /**
     * 
     * @type {string}
     * @memberof APIContractSearchResult
     */
    requestContactFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContractSearchResult
     */
    requestContactEmail?: string;
    /**
     * 
     * @type {number}
     * @memberof APIContractSearchResult
     */
    articleCount?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof APIContractSearchResult
     */
    articleIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIContractSearchResult
     */
    articleNames?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIContractSearchResult
     */
    articleNumbers?: Array<string>;
    /**
     * 
     * @type {Array<APIArticle>}
     * @memberof APIContractSearchResult
     */
    articles?: Array<APIArticle>;
    /**
     * 
     * @type {APIAddress}
     * @memberof APIContractSearchResult
     */
    shippingAddress?: APIAddress | null;
    /**
     * 
     * @type {APIAddress}
     * @memberof APIContractSearchResult
     */
    billingAddress?: APIAddress | null;
    /**
     * 
     * @type {string}
     * @memberof APIContractSearchResult
     */
    shippingCity?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContractSearchResult
     */
    shippingCountry?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIContractSearchResult
     */
    editorIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIContractSearchResult
     */
    editorEmails?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIContractSearchResult
     */
    readByIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIContractSearchResult
     */
    rootAccountId?: string | null;
}

/**
 * Check if a given object implements the APIContractSearchResult interface.
 */
export function instanceOfAPIContractSearchResult(value: object): value is APIContractSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    return true;
}

export function APIContractSearchResultFromJSON(json: any): APIContractSearchResult {
    return APIContractSearchResultFromJSONTyped(json, false);
}

export function APIContractSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIContractSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'score': json['score'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'contractStatus': json['contract_status'] == null ? undefined : json['contract_status'],
        'contractStatusDisplay': json['contract_status_display'] == null ? undefined : json['contract_status_display'],
        'priorityShipping': json['priority_shipping'] == null ? undefined : json['priority_shipping'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'desiredDelivery': json['desired_delivery'] == null ? undefined : (new Date(json['desired_delivery'])),
        'latestDelivery': json['latest_delivery'] == null ? undefined : (new Date(json['latest_delivery'])),
        'priceEntries': json['price_entries'] == null ? undefined : ((json['price_entries'] as Array<any>).map(APIPriceEntryFromJSON)),
        'priceQuantities': json['price_quantities'] == null ? undefined : json['price_quantities'],
        'priceValues': json['price_values'] == null ? undefined : json['price_values'],
        'priceText': json['price_text'] == null ? undefined : json['price_text'],
        'offerId': json['offer_id'] == null ? undefined : json['offer_id'],
        'requestId': json['request_id'] == null ? undefined : json['request_id'],
        'requestCertificate': json['request_certificate'] == null ? undefined : json['request_certificate'],
        'requestStatus': json['request_status'] == null ? undefined : json['request_status'],
        'requestStatusDisplay': json['request_status_display'] == null ? undefined : json['request_status_display'],
        'requestContact': json['request_contact'] == null ? undefined : APIRequestContactFromJSON(json['request_contact']),
        'requestContactFullName': json['request_contact_full_name'] == null ? undefined : json['request_contact_full_name'],
        'requestContactEmail': json['request_contact_email'] == null ? undefined : json['request_contact_email'],
        'articleCount': json['article_count'] == null ? undefined : json['article_count'],
        'articleIds': json['article_ids'] == null ? undefined : json['article_ids'],
        'articleNames': json['article_names'] == null ? undefined : json['article_names'],
        'articleNumbers': json['article_numbers'] == null ? undefined : json['article_numbers'],
        'articles': json['articles'] == null ? undefined : ((json['articles'] as Array<any>).map(APIArticleFromJSON)),
        'shippingAddress': json['shipping_address'] == null ? undefined : APIAddressFromJSON(json['shipping_address']),
        'billingAddress': json['billing_address'] == null ? undefined : APIAddressFromJSON(json['billing_address']),
        'shippingCity': json['shipping_city'] == null ? undefined : json['shipping_city'],
        'shippingCountry': json['shipping_country'] == null ? undefined : json['shipping_country'],
        'editorIds': json['editor_ids'] == null ? undefined : json['editor_ids'],
        'editorEmails': json['editor_emails'] == null ? undefined : json['editor_emails'],
        'readByIds': json['read_by_ids'] == null ? undefined : json['read_by_ids'],
        'rootAccountId': json['root_account_id'] == null ? undefined : json['root_account_id'],
    };
}

export function APIContractSearchResultToJSON(value?: APIContractSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'score': value['score'],
        'comment': value['comment'],
        'contract_status': value['contractStatus'],
        'contract_status_display': value['contractStatusDisplay'],
        'priority_shipping': value['priorityShipping'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt'] as any).toISOString()),
        'desired_delivery': value['desiredDelivery'] == null ? undefined : ((value['desiredDelivery'] as any).toISOString().substring(0,10)),
        'latest_delivery': value['latestDelivery'] == null ? undefined : ((value['latestDelivery'] as any).toISOString().substring(0,10)),
        'price_entries': value['priceEntries'] == null ? undefined : ((value['priceEntries'] as Array<any>).map(APIPriceEntryToJSON)),
        'price_quantities': value['priceQuantities'],
        'price_values': value['priceValues'],
        'price_text': value['priceText'],
        'offer_id': value['offerId'],
        'request_id': value['requestId'],
        'request_certificate': value['requestCertificate'],
        'request_status': value['requestStatus'],
        'request_status_display': value['requestStatusDisplay'],
        'request_contact': APIRequestContactToJSON(value['requestContact']),
        'request_contact_full_name': value['requestContactFullName'],
        'request_contact_email': value['requestContactEmail'],
        'article_count': value['articleCount'],
        'article_ids': value['articleIds'],
        'article_names': value['articleNames'],
        'article_numbers': value['articleNumbers'],
        'articles': value['articles'] == null ? undefined : ((value['articles'] as Array<any>).map(APIArticleToJSON)),
        'shipping_address': APIAddressToJSON(value['shippingAddress']),
        'billing_address': APIAddressToJSON(value['billingAddress']),
        'shipping_city': value['shippingCity'],
        'shipping_country': value['shippingCountry'],
        'editor_ids': value['editorIds'],
        'editor_emails': value['editorEmails'],
        'read_by_ids': value['readByIds'],
        'root_account_id': value['rootAccountId'],
    };
}

